'use strict';

import SearchRoutesForm from "../components/SearchRoutesForm";

class AircraftSearchContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <div>
            <SearchRoutesForm
                showSwitchTab={false}
            />
        </div>
    }
}

const domContainer = document.querySelector('#reactAircraftSearchContainer');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(AircraftSearchContainer));
